import { render, staticRenderFns } from "./ProductMarketplacesManagerItem.vue?vue&type=template&id=5a805869"
import script from "./ProductMarketplacesManagerItem.vue?vue&type=script&lang=js"
export * from "./ProductMarketplacesManagerItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports